// @flow
export const CAFETERIA_TYPE_DEFAULT = null;
export const CAFETERIA_TYPE_ITEKO = 'iteko';
export const CAFETERIA_TYPE_GLOLIME = 'glolime';

export type CafeteriaType = typeof CAFETERIA_TYPE_DEFAULT | typeof CAFETERIA_TYPE_ITEKO | typeof CAFETERIA_TYPE_GLOLIME;
